import React from "react";

export const PageHero = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative overflow-hidden bg-brand-beige border-b border-brand-beige"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          {eyebrow && (
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-brand-maroon mb-4">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-base md:text-lg text-brand-ink/70 max-w-xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="md:col-span-5">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-white shadow-sm border border-brand-beige">
              <img
                src={image}
                alt={title}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
